import Component from '@glimmer/component'
import { service } from '@ember/service'
import type FlashQueueService from 'district-ui-client/services/flash-queue'
import { Toast } from 'district-ui-client/components/toast'

import { modifier } from 'ember-modifier'

interface ShowOnToastSignature {
  Element: Element
  Args: {
    Positional: [flashes?: unknown[]]
  }
}

/**
 * Show only when there are flashes, to ensure the flash/popover is last thing added to top-layer - useful if there are
 * other things in the top-layer.
 * If popover is already showing, calling showPopover again will put it back to top of top-layer.
 */
const showOnToast = modifier<ShowOnToastSignature>(function (el, [toasts]) {
  if (el instanceof HTMLElement && toasts?.length) {
    el.showPopover?.()
  }
})

interface Signature {
  Element: Element
}

/**
 * This component creates the container to display messages within.
 * @see https://github.com/poteto/ember-cli-flash
 */
export class Toaster extends Component<Signature> {
  @service flashQueue!: FlashQueueService

  <template>
    <flash-queue
      {{! disable pointer events (click/hover) to allow mouse events _between_ flash messages to go through to page }}
      {{! unset inset to undo some default browser styles for popovers }}
      class="pointer-events-none inset-[unset] block space-y-3 overflow-visible bg-transparent p-0 print:hidden"
      {{! Implemented via HTML Popover API, to appear in the top-layer }}
      popover
      {{showOnToast this.flashQueue.queue}}
      ...attributes
    >
      {{#each this.flashQueue.queue as |flashObject|}}
        <Toast @flash={{flashObject}} />
      {{/each}}
    </flash-queue>
  </template>
}

export default Toaster
